import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 4.89rem;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    margin-left: 0;
    margin-top: 2rem;
  }
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  font-family: 'RedHatDisplay-Bold';
  line-height: 3rem;
  margin-bottom: 0.5rem;

  > h1 {
    font-size: 1.56rem;
    color: #1e88e5;
    text-align: center;
    margin-left: 0.6rem;
  }

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const NotificationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`;

export const NotificationList = styled.ul`
  margin-top: 0.5rem;
  max-height: 19.44rem; /* Altura aproximada para 5 notificações */
  overflow-y: auto;

  li {
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 0.67rem 0;
      background: transparent;
      border: none;
      text-align: left;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #f5f5f5;
      }

      img {
        width: 1.33rem;
        height: 1.33rem;
        margin-right: 0.67rem;
      }

      div {
        flex: 1;
        position: relative;
        p {
          margin: 0;
          font-size: 0.8rem;
          line-height: 1.4;
          text-align: left;
          > b {
            font-family: 'RedHatDisplay-Bold';
            font-size: 0.8rem;
          }
        }
      }
    }
  }
`;

export const NotificationTime = styled.span`
  position: absolute;
  margin-right: 0.3rem;
  bottom: -0.67rem;
  right: 0;
  font-size: 0.67rem;
  color: #6c757d;
  font-style: italic;
`;
